export default {
  retrieveBusNotificationTemplateList (state, payload) {
    state.busNotificationTemplateList = [].concat(payload.busNotificationTemplateList)
  },
  getBusNotificationTemplateInfo (state, payload) {
    state.busNotificationTemplateInfo = payload.busNotificationTemplateInfo
    if (state.busNotificationTemplateInfo.category_info == null) {
      state.busNotificationTemplateInfo.category_info = { id: "", name: "" }
    }
  },
  deleteBusNotificationTemplate (state, payload) {
    state.busNotificationTemplateList.forEach((item, index) => {
      if (item.id === payload.busNotificationTemplateInfo.bus_notification_template_id) {
        state.busNotificationTemplateList.splice(index, 1)
      }
    })
  },
  retrieveBusNotificationCategoryList (state, payload) {
    state.categoriesList = [].concat(payload.busNotificationCategoryList)
  },
  retrieveBusNotificationCategoryInfo (state, payload) {
    state.categoryInfo = payload.busNotificationCategoryInfo
  },
  deleteBusNotificationCategory (state, payload) {
    state.categoriesList.splice(payload.busNotificationCategoryInfo.index, 1);
  },
  updateState (state, payload) {
    state.currentPage = payload.page ? payload.page : null
  }
}
